import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  children,
  onClick,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  type = 'button',
  fullWidth = false,
  className = '',
  ...props
}) => {
  const baseClasses =
    'tw-font-semibold tw-rounded-lg tw-transition-all tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 tw-cursor-pointer';

  const variants = {
    primary:
      'tw-bg-[linear-gradient(90deg,#0843fe_0%,_#4995fb_100%)] tw-text-white hover:tw-opacity-90 focus:tw-ring-blue-500',
    secondary: 'tw-bg-gray-200 tw-text-gray-800 hover:tw-bg-gray-300 focus:tw-ring-gray-500',
    outline: 'tw-border tw-border-gray-300 tw-text-gray-700 hover:tw-bg-gray-50 focus:tw-ring-gray-500',
  };

  const sizes = {
    small: 'tw-px-3 tw-py-1.5 tw-text-sm sm:tw-px-4 sm:tw-py-2',
    medium: 'tw-px-4 tw-py-2.5 tw-text-base sm:tw-px-6 sm:tw-py-3',
    large: 'tw-px-6 tw-py-3 tw-text-lg sm:tw-px-8 sm:tw-py-4',
  };

  const buttonClasses = `
    ${baseClasses} 
    ${variants[variant]} 
    ${sizes[size]} 
    ${fullWidth ? 'tw-w-full' : ''} 
    ${disabled ? 'tw-cursor-not-allowed tw-opacity-50' : ''}
    ${className}
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses} {...props}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
